'use client';

import React, { useCallback } from 'react';

export const SkipLink = (props: { focusTargetSelector?: string }) => {
  const { focusTargetSelector } = props;
  const handleSkip = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();

      const main = document.querySelector<HTMLElement>('main');
      if (!main) return;

      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
      ];

      const firstFocusable = focusTargetSelector
        ? main.querySelector<HTMLElement>(focusTargetSelector)
        : main.querySelector<HTMLElement>(focusableSelectors.join(','));

      const target = firstFocusable || main;

      const hasTabindex = target.hasAttribute('tabindex');
      if (!hasTabindex) target.setAttribute('tabindex', '-1');

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus();

      target.addEventListener(
        'blur',
        () => {
          if (!hasTabindex) target.removeAttribute('tabindex');
        },
        { once: true },
      );
    },
    [focusTargetSelector],
  );

  return (
    <div className="container relative mx-auto px-1 md:px-2 lg:px-4">
      <button
        onClick={handleSkip}
        aria-label="Salta al contenuto principale"
        className="focus:ring-primary absolute -top-10 left-2 z-50 rounded-md bg-white px-4 py-1 text-sm font-medium shadow-md focus:top-24 focus:outline-none focus:ring-2 focus:transition-all"
      >
        Skip to main content
      </button>
    </div>
  );
};
